.BreadCrumb {
  padding-top: 20px;
  width: fit-content;
  font-size: 14px;
  display: flex;
  align-items: center;

  &-link {
    display: flex;
    align-items: center;
    color: var(--gray);
  }

  &-title {
    color: var(--color_primary_500);
  }
}